import { render, staticRenderFns } from "./ResetPassword.html?vue&type=template&id=4bee8ef3&scoped=true&external"
import script from "./ResetPassword.js?vue&type=script&lang=js&external"
export * from "./ResetPassword.js?vue&type=script&lang=js&external"
import style0 from "./ResetPassword.scss?vue&type=style&index=0&id=4bee8ef3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee8ef3",
  null
  
)

export default component.exports